<template>
  <div class="inspectionIncomingDetailEdit">
    <el-dialog
        :visible.sync="dialogVisible"
        append-to-body
        :title="inspectionReport.pkid > 0 ? '质量检验编辑':'质量检验新建'"
        class="customer-edit"
        width="1400px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          style="position: relative"
          :model="inspectionReport"
          :rules="ruleValidate"
          class="form"
          label-width="120px">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="基本信息" name="first">
            <el-row>
              <el-col :span="8">
                <el-form-item label="物料号：">
                  <el-input v-model="inspectionReport.materialNo" @change="selectNameByNo"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="物料描述：">
                  <el-input v-model="inspectionReport.materialName"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="报告单号：">
                  <el-input v-model="inspectionReport.no"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="基准：">
                  <el-input v-model="inspectionReport.standards"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="实际：">
                  <el-input v-model="inspectionReport.practical"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="问题分类：">
                  <el-select
                      v-model.trim="inspectionReport.problemClassification"
                      clearable
                      placeholder="请选择">
                    <el-option
                        v-for="item in constants.problemClassification_LL.$options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"/>
                  </el-select>
                  <el-select
                      v-if="inspectionReport.storageInspectionType === 20"
                      v-model.trim="inspectionReport.problemClassification"
                      clearable
                      placeholder="请选择">
                    <el-option
                        v-for="item in constants.problemClassification_RJ.$options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"/>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="16">
                <el-form-item label="问题初步调查：">
                  <el-input v-model="inspectionReport.preliminaryInvestigation" type="textarea"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="实际不良总数：" :span="8">
                  <el-input v-model="inspectionReport.badQuality" type="number" min="1"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="是否处理：">
                  <el-radio-group v-model="inspectionReport.needHandle">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="区域负责工程师：">
                  <el-input v-model="inspectionReport.regionalManager" placeholder="请选择" readonly>
                    <el-button slot="append" icon="el-icon-search" @click="$refs.selectRegionalManager.open()"/>
                  </el-input>
                  <user-select ref="selectRegionalManager" @select="selectRegionalManager"/>
                </el-form-item>
              </el-col>
              <el-col v-if="inspectionReport.needHandle" :span="8">
                <el-form-item label="处理人：">
                  <el-input v-model="inspectionReport.handleName" placeholder="请选择" readonly>
                    <el-button slot="append" icon="el-icon-search" @click="$refs.selectHandle.open()"/>
                  </el-input>
                  <user-select ref="selectHandle" @select="onSelectHandle"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="责任部门接口人：">
                  <el-input v-model="inspectionReport.responsibleName" placeholder="请选择" readonly>
                    <el-button slot="append" icon="el-icon-search" @click="$refs.selectResponsibleName.open()"/>
                  </el-input>
                  <user-select ref="selectResponsibleName" @select="onSelectResponsibleName"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="责任部门：">
                  <el-input v-model="inspectionReport.responsibleDepartment"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="是否批次问题：">
                  <el-radio-group v-model="inspectionReport.batchProblem">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="检验项目">
              <el-checkbox-group v-model="inspectionReport.inspectionDetailVOS" @change="projectTypeChange">
                <el-checkbox v-for="item in inspectionReport.inspectionTemplateDetailVOS" :key="item.pkid" :label="item.inspectionName">{{item.inspectionName}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <div style="padding: 0 0 10px 10px;width: 90%;margin: 0 auto">
              <div>
                <el-form
                    ref="formUplosd"
                    enctype="multipart/form-data"
                    label-position="right"
                    label-width="120px"
                    size="mini">
                  <div style="display: flex;flex-direction: row;align-items: center;justify-content: space-between">
                    <div>
                      <div v-if="!inspectionReport.accessoryList || !inspectionReport.accessoryList.length">暂无附件</div>
                      <table width="100%">
                        <tr v-for="(item, index) in inspectionReport.accessoryList" :key="index">
                          <td>附件{{index + 1}}</td>
                          <td style="cursor: pointer;padding:5px;color: #20a0ff" @click="openFile(item)">{{item.fileName}}</td>
                          <td style="padding:5px"><el-input v-model="item.note" size="mini"/></td>
                          <td style="padding:5px;color: #20a0ff;cursor: pointer;" @click="deleteFile(index)">删除</td>
                        </tr>
                      </table>
                    </div>
                    <div>
                      <el-upload
                          action=""
                          multiple
                          :http-request="submitUpload"
                          :show-file-list="false"
                          :disabled="uploadLoading"
                          style="display: inline-block; float: right; margin: 5px;">
                        <el-button type="primary" plain>
                          <i class="el-icon-upload el-icon--right"/>
                          附件上传
                        </el-button>
                      </el-upload>
                    </div>
                  </div>
                </el-form>
              </div>
            </div>
            <!--            <el-table-->
            <!--                :data="inspectionReport.accessories"-->
            <!--                max-height="200"-->
            <!--                default-expand-all-->
            <!--                style="width: 100%;margin-top: 3px">-->
            <!--              <el-table-column align="center" label="附件名称" prop="accessoryName"/>-->
            <!--              <el-table-column-->
            <!--                  label="操作"-->
            <!--                  align="center"-->
            <!--                  class-name="vm-table_operate"-->
            <!--                  width="450">-->
            <!--                <template slot-scope="scope">-->
            <!--                  <el-button type="primary" @click="downloadExcel(scope.row)">下载</el-button>-->
            <!--                </template>-->
            <!--              </el-table-column>-->
            <!--            </el-table>-->
          </el-tab-pane>
          <el-tab-pane v-if="inspectionReport.pkid > 0" label="工作流详情" name="third">
            <handle-detail :bill-id="billId" :bill-type="billType" sequ-id="-1"/>
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <span slot="footer">
        <el-button type="info" @click="dialogVisible=false">关闭</el-button>
        <el-button type="primary" @click="reportSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "../../../util/constant";
  import constants from "../../../util/constants";
  import UserSelect from "@/views/SystemInfo/SystemUser/UserSelect";
  import HandleDetail from "@/views/workFlow/HandleDetail";
  import loginUtil from "@/util/loginUtil";

  export default {
    name: "InspectionShipmentDetailEdit",
    components: {UserSelect, HandleDetail},
    data() {
      return {
        constant,
        constants,
        uploadLoading: false,
        billId: "0",
        index: 0,
        billType: "29",
        handleType: constant.toSelect(constant.handleType),
        exportLoading: false,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        saveLoading: false,
        activeName: "first",
        barCode: "",
        value: "",
        inspectionReport: {
          pkid: 0,
          barCode: "",
          voucherNo: "",
          no: "",
          billID: "",
          billType: "",
          inspectionType: 10,
          storageInspectionType: 30,
          conclusion: 0,
          inspectionResult: false,
          needHandle: true,
          batchProblem: false,
          handleType: 10,
          processMode: "",
          materialNo: "",
          materialName: "",
          handleDepartment: "",
          standards: "",
          practical: "",
          problemClassification: "",
          badQuality: "",
          preliminaryInvestigation: "",
          responsibleDepartment: "",
          responsibleID: "",
          responsibleName: "",
          supplierID: "",
          supplierName: "",
          regionalID: "",
          regionalManager: "",
          handleID: "",
          handleName: "",
          qualitativeClassification: "",
          createdTime: "",
          inspectorName: "",
          accessories: [],
          inspectionMaterials: [],
          accessoryList: [],
          countersignVOS: [],
          inspectionTemplateDetailVOS: [],
          inspectionDetailVOS: ["A:包装","B:标识","C:外观","D:规格型号"],

        },
        ruleValidate: {
          regionalManager: {required: true, message: "不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(row,index) {
        this.inspectionReport.pkid = row.pkid;
        this.index = index;
        this.billId = row.pkid + "";
        this.barCode = row.barcode;
        this.dialogVisible = true;
        if (this.inspectionReport.pkid > 0) {
          this.getData();
        }else {
          this.inspectionReport = row;
        }
      },
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `inspectionReports/selectReportByPKID_CH/${this.inspectionReport.pkid}`)
          .then(resp => {
            console.log(resp);
            this.inspectionReport = resp;
            this.contentLoading = false;
          });
      },
      projectTypeChange(value) {
        let id = this.inspectionReport.pkid;
        if (value.toString().includes("G:尺寸") || value.toString().includes("H:性能")) {
          let routeData = this.$router.resolve({path: "/printRMIR/" +  id});
          window.open(routeData.href, "_blank");
          // this.$router.push({
          //   path: "/printRMIR",
          //   query: {
          //     id: this.inspectionReport.pkid,
          //     inspectionReport: this.inspectionReport,
          //   },
          // });
        }
        // console.log(value);
      },
      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("files", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "file/batch/0", formData)
          .then((res) => {
            this.uploadLoading = false;
            // this.saveAttachments(res.data.attachments, 0);
            const fileInfo = res.data.attachments[0];
            console.log(fileInfo);
            this.inspectionReport.accessoryList.push({
              fileName: fileInfo.fileName,
              filePath: "/attached/file/" + fileInfo.filePath,
              note: "",
            });
            this.$message.success("上传成功");
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },
      deleteFile(index) {
        this.inspectionReport.accessoryList.splice(index, 1);
      },
      openFile(item) {
        console.log(item);
        let a = document.createElement("a");
        a.href = "http://emes.stepelectric.com" + item.filePath;
        a.target = "_blank";
        a.download = item.filePath;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      },
      getFormatDate(date) {
        let month = date.getMonth() + 1;
        let strDate = date.getDate();
        let hours = date.getHours();
        let minutes = date.getMinutes();
        let seconds = date.getSeconds();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        if (hours >= 0 && hours <= 9) {
          hours = "0" + hours;
        }
        if (minutes >= 0 && minutes <= 9) {
          minutes = "0" + minutes;
        }
        if (seconds >= 0 && seconds <= 9) {
          seconds = "0" + seconds;
        }
        return date.getFullYear() + "-" + month + "-" + strDate + " " + hours + ":" + minutes + ":" + seconds;
      },
      onSelectHandle(row) {
        console.log(row);
        this.inspectionReport.handleID = row.systemUserID;
        this.inspectionReport.handleName = row.employeeName;
      },
      onSelectResponsibleName(row) {
        console.log(row);
        this.inspectionReport.responsibleID = row.systemUserID;
        this.inspectionReport.responsibleName = row.employeeName;
        this.inspectionReport.responsibleDepartment = row.departmentName;
      },
      selectRegionalManager(row) {
        console.log(row);
        this.inspectionReport.regionalID = row.systemUserID;
        this.inspectionReport.regionalManager = row.employeeName;
      },
      onSelectCountersign(row) {
        this.inspectionReport.countersignID = row.systemUserID;
        this.inspectionReport.countersignName = row.employeeName;
      },
      onSelectRework(row) {
        this.inspectionReport.reworkID = row.systemUserID;
        this.inspectionReport.reworkName = row.employeeName;
      },
      onSelectSupplier(row) {
        this.inspectionReport.supplierID = row.pkid;
        this.inspectionReport.supplierName = row.name;
      },
      downloadExcel(row) {
        console.log(row.filePath);
        let a = document.createElement("a");
        a.href = row.filePath;
        a.download = row.accessoryName;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      },
      selectNameByNo() {
        if (this.inspectionReport.materialNo.length > 0) {
          let params = {
            no: this.inspectionReport.materialNo,
          };
          this.$http
            .get("basic", "baseMaterials/selectNameByNo", params)
            .then((res) => {
              this.inspectionReport.materialName = res;
              console.log(res);
            });
        }

      },
      reportSave() {
        this.$emit("save-success", this.inspectionReport,this.index);
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang="scss">
  .inspectionIncomingDetailEdit {
    .table {
      width: 100%;
      margin: 2% auto;
      border-top: 1px solid #dddddd;
      border-left: 1px solid #dddddd;

      .tableLabel {
        width: 130px;
        padding: 1%;
        background: #f4f7fa;
        border-bottom: 1px solid #dddddd;
      }

      .tableModel {
        width: 20%;
        padding: 1%;
        border-left: 1px solid #dddddd;
        border-right: 1px solid #dddddd;
        border-bottom: 1px solid #dddddd;
      }
    }
  }

</style>
